const envFlag = process.env.REACT_APP_IS_DEV;

// Jamais en build de production, quelle que soit la variable : sinon un jeton
// de dev serait envoyé pour tous les visiteurs.
export const IS_DEV =
  process.env.NODE_ENV !== "production" &&
  ["true", "1", "yes", "on"].includes(String(envFlag || "").trim().toLowerCase());
// En local : REACT_APP_DEV_TOKEN dans .env.local, ou localStorage.setItem("token", "<jwt>").
// Aucun jeton dans le code source.
export const DEV_TOKEN = IS_DEV ? process.env.REACT_APP_DEV_TOKEN || "" : "";

export const AUTH_BASE_URL =
  process.env.REACT_APP_AUTH_BASE_URL || "https://auth.teqa.net/auth/";

export const INTEGRATION_API_BASE_URL =
  process.env.REACT_APP_INTEGRATION_API_BASE_URL ||
  "https://integration.teqa.net/api/";

export const INTEGRATION_BASE_URL =
  process.env.REACT_APP_INTEGRATION_BASE_URL ||
  "https://integration.teqa.net/";

// Catalogue des sociétés de livraison (profil marketplace : "avec qui je travaille déjà")
export const DELIVERY_BASE_URL =
  process.env.REACT_APP_DELIVERY_BASE_URL || "https://delivery.teqa.net/";

export const MARKETPLACE_BASE_URL =
  process.env.REACT_APP_MARKETPLACE_BASE_URL || "https://marketplace.teqa.net/";

export const LOGIN_REDIRECT_URL =
  process.env.REACT_APP_LOGIN_URL || "https://teqa.net/login";
